export default __webpack_public_path__ + "static/media/detalle_impuesto.9f546db2.svg";